import React from "react";
import { useLocation, useOutletContext } from "react-router";
import { Modal } from "./modal";
import { IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";

const Confirmation = ({ title, message, handleConfirm, handleCancel }) => {
  const location = useLocation();

  const theme = useOutletContext()?.theme || "";

  const setting = useSelector((state) => state?.user?.setting);
  const { isDarkMode } = useSelector((state) => state.scheduler);

  const isClassName = () => {
    if (location.pathname.includes("shop")) {
      const shopTheme =
        theme ||
        document
          .querySelector("footer")
          ?.className.split(" ")
          .find((cls) => cls.startsWith("theme-"));
      return shopTheme || "";
    }

    if (["scheduler", "detailEvent"].some((name) => location.pathname.includes(name))) {
      return isDarkMode ? "dark" : "white";
    }

    if (location.pathname.includes("mypage")) {
      return setting?.mode || "";
    }

    return "";
  };

  return (
    <Modal className={isClassName()}>
      <div className="modal">
        <div className="info">
          <span>{title}</span>
          <button onClick={handleCancel}>
            <IoClose />
          </button>
        </div>
        <div className="message">
          {message.map((item) => (
            <span>{item}</span>
          ))}
        </div>
        <div className="actions">
          <button onClick={handleCancel}>취소</button>
          <button onClick={handleConfirm}>확인</button>
        </div>
      </div>
    </Modal>
  );
};

export default Confirmation;
